import type { UseModalProps } from "@chakra-ui/react";
import { ModalEditContractForm } from "@components/modules/documents/listing/form/contract/ModalEditContractForm";
import {
  RelatedTo,
  StoreContractForm,
} from "@components/modules/documents/listing/form/contract/StoreContractForm";
import { t } from "@lingui/macro";
import { useCreateContractMutation } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { FormMode } from "@src/utils/types";
import { filter, omit } from "lodash";
import { observer } from "mobx-react-lite";
import { type FunctionComponent, useEffect, useState } from "react";
import { useStore } from "../../store";

export const ModalCreateContract: FunctionComponent<UseModalProps> = observer(
  function AddContract(props) {
    const store = useStore();

    const [contractStore] = useState(() => {
      const s = StoreContractForm.create();
      s.relatedToOptions = filter(
        s.relatedToOptions,
        (f) => f.value === RelatedTo.Contractor,
      );
      s.form.related_to.onChange(RelatedTo.Contractor);
      return s;
    });

    const [create, createReq] = useCreateContractMutation({
      onCompleted(data) {
        store.refetchContractsOptions?.();
        store.form.contract_id.onChange(data.createContract.id);
        props.onClose();
      },
      ...onError(),
    });

    useEffect(() => {
      const c = store.contractor;
      if (c) {
        contractStore.contractorOptions = [
          { label: c.legal_name, value: c.id },
        ];
        contractStore.form.contractor_id.onChange(c.id);
      }
    }, [store.contractor]);

    return (
      <ModalEditContractForm
        {...props}
        title={t`Add new contract`}
        mode={FormMode.CREATE}
        store={contractStore}
        primaryActionContent={t`Save document`}
        loading={createReq.loading}
        onSubmit={(vars) => {
          create({
            variables: { input: { ...omit(vars, "valid_to_indefinite") } },
          });
        }}
      />
    );
  },
);
